import { ElMessage } from 'element-plus'

export class AuthService {
    // 初始化游客用户
    static initGuestUser() {
        const guestUser = {
            userId: 'guest',
            id: 'guest',
            userName: '游客',
            handle: 'guest',
            email: '',
            role: 'guest',
            avatarUrl: ''
        }
        return guestUser
    }

    // 检查是否为游客
    static isGuest(user) {
        return !user || user.userId === 'guest' || user.id === 'guest'
    }

    // 检查是否为系统管理员
    static isSystemAdmin(user) {
        return user && (user.role === 'systemAdmin')
    }

    // 检查登录状态
    static checkLoginStatus(store = null) {
        const userStr = localStorage.getItem('user')

        if (!userStr) {
            if (store) store.commit('LOGOUT')
            return { isValid: false, reason: 'no_user_data', isGuest: true }
        }

        let user;
        try {
            user = JSON.parse(userStr);
        } catch (e) {
            if (store) store.commit('LOGOUT');
            return { isValid: false, reason: 'invalid_data', isGuest: true };
        }

        if (user.userId === 'guest' || user.id === 'guest') {
            return { isValid: false, reason: 'guest_user', isGuest: true }
        }

        const expires = localStorage.getItem('expires')
        if (expires && new Date(expires) < new Date()) {
            if (store) store.commit('LOGOUT')
            return { isValid: false, reason: 'expired', isGuest: true }
        }

        return { isValid: true, userId: user.userId || user.id, user, isGuest: false }
    }

    static clearLoginData() {
        localStorage.removeItem('userId')
        localStorage.removeItem('userName')
        localStorage.removeItem('expires')
        localStorage.removeItem('userAvatar')
        localStorage.removeItem('user')
        localStorage.removeItem('token')
        localStorage.removeItem('access_token')
        localStorage.removeItem('refresh_token')
        sessionStorage.removeItem('oauth_state')
    }
}
